(function() {
    var m = angular.module('utils');

    m.directive('month', [function() {
        return {
            require: 'ngModel',
            priority: 1,
            link: function(scope, elm, attrs, ngModel) {

                var e = $(elm);

                var months = ['января',
                    'февраля',
                    'марта',
                    'апреля',
                    'мая',
                    'июня',
                    'июля',
                    'августа',
                    'сентября',
                    'октября',
                    'ноября',
                    'декабря'
                ];

                function fillMonths() {
                    e.html('');
                    for (var i = 0; i < 12; i++) {
                        e.append($('<option>').val(i + 1).html(months[i]));
                    }
                }

                scope.$watch(function() {
                    return ngModel;
                }, function() {
                    fillMonths();
                    e.val(ngModel.$viewValue);
                });
            }
        };
    }]);
})();
